import {
  NormalBrowseFileInputFiled,
  NormalTextEditorInputFiled,
  NormalTextInputField,
} from "@/components";
import React, { useMemo } from "react";

const PrivacyAndQualityPolicyCMSForm = ({
  activeTab,
  isFetching,
  formData,
  selectedTab,
  allFilesResponse,
  searchValue,
  selectedFileType,
  handleTextInputChange,
  handleTextEditorInputChange,
  handleImageChange,
  adminRole,
  permissionsList,
}) => {
  const isHideInOtherLanguages = useMemo(() => {
    return activeTab === "en" ? true : false;
  }, [activeTab]);

  return (
    <>
      {selectedTab === "section-1" && (
        <>
          {/* Banner Image */}
          {isHideInOtherLanguages && (
            <NormalBrowseFileInputFiled
              isFetching={isFetching}
              labelText="Banner Image"
              fieldId="privacy-and-quality-policy-banner-image"
              allFilesResponse={allFilesResponse}
              searchValue={searchValue}
              selectedFileType={selectedFileType}
              onChangeImageFunction={(id) =>
                id
                  ? handleImageChange(
                      "privacy-and-quality-policy-banner-image",
                      id
                    )
                  : handleImageChange(
                      "privacy-and-quality-policy-banner-image",
                      ""
                    )
              }
              selectedFileId={
                formData?.["privacy-and-quality-policy-banner-image"] || ""
              }
              adminRole={adminRole}
              permissionsList={permissionsList}
              infoText="Recommended size: 1300 x 650px"
            />
          )}

          {/* Banner Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Banner Heading"
            fieldId="privacy-and-quality-policy-banner-heading"
            fieldName="privacy-and-quality-policy-banner-heading"
            placeholderText="Banner Heading"
            inputValue={
              formData?.["privacy-and-quality-policy-banner-heading"] || ""
            }
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* Banner Description */}
          <NormalTextInputField
            isFetching={isFetching}
            isTextArea={true}
            labelText="Banner Description"
            fieldId="privacy-and-quality-policy-banner-description"
            fieldName="privacy-and-quality-policy-banner-description"
            placeholderText="Banner Description"
            inputValue={
              formData?.["privacy-and-quality-policy-banner-description"] || ""
            }
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* Content Text */}
          <NormalTextEditorInputFiled
            isFetching={isFetching}
            labelText="Content Text"
            fieldId="privacy-and-quality-policy-content"
            fieldName="privacy-and-quality-policy-content"
            placeholderText="Content Text"
            inputValue={formData?.["privacy-and-quality-policy-content"] || ""}
            onChangeTextEditorFiled={handleTextEditorInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />
        </>
      )}
    </>
  );
};

export default PrivacyAndQualityPolicyCMSForm;
